import { SOL_SERVER_BASE_URL } from "@/env";

/** Published Swivu MCP server URL (Sol host + /mcp). */
export const getSwivuMcpServerUrl = (): string => `${SOL_SERVER_BASE_URL}/mcp`;

/**
 * Step 1 — connect Swivu MCP in any AI client. Tool conventions (confirm previews, names over ids)
 * come from the MCP server's own instructions, so they are intentionally not repeated here.
 */
export const buildSwivuMcpConnectPrompt = (
  mcpServerUrl: string = getSwivuMcpServerUrl()
): string =>
  [
    "Connect Swivu MCP so you can use its tools on my Swivu boards.",
    "",
    "Server URL (remote MCP, streamable HTTP):",
    mcpServerUrl,
    "",
    "If you can't add it yourself, walk me through adding it as a custom/remote MCP server in your settings, using your actual menu names. Choose OAuth / browser sign-in when asked for authentication.",
    "",
    "Once I confirm it's connected, call `get_me` and tell me which boards I can access. If the Swivu tools still aren't available, tell me what's missing instead of guessing.",
  ].join("\n");

/**
 * Step 2 — apply the board workflow (assumes Swivu MCP is already connected).
 * The markdown file is attached separately; do not embed its contents or a filename in this prompt.
 */
export const buildSwivuMcpWorkflowPrompt = (): string =>
  [
    "I've attached my board workflow file. Use the Swivu MCP tools to work on my board, and treat the attached file as the source of truth for how this board operates: naming, statuses, process, and constraints. If a request conflicts with it, point out the conflict and ask me before proceeding.",
    "",
    "If the Swivu tools aren't available, stop and tell me Step 1 isn't done. Don't make up board state.",
    "",
    "Read the attached file before you start. Do not ask me to paste the workflow into the chat.",
  ].join("\n");
